import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a timestamp to a localized date string
 * Handles both Unix timestamps (seconds) and milliseconds
 * Also handles snake_case (created_at) and camelCase (createdAt) field names
 */
export function formatDate(timestamp: number | string | undefined | null): string {
  if (timestamp === undefined || timestamp === null || timestamp === '') {
    return '-';
  }

  // Convert string to number if needed
  const ts = typeof timestamp === 'string' ? parseInt(timestamp, 10) : timestamp;

  if (isNaN(ts) || ts === 0) {
    return '-';
  }

  // If timestamp is in seconds (less than year 3000 in seconds), convert to milliseconds
  // Year 3000 in seconds is roughly 32503680000
  const msTimestamp = ts < 32503680000 ? ts * 1000 : ts;

  const date = new Date(msTimestamp);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleDateString();
}

/**
 * Format a timestamp to a localized date and time string
 */
export function formatDateTime(timestamp: number | string | undefined | null): string {
  if (timestamp === undefined || timestamp === null || timestamp === '') {
    return '-';
  }

  const ts = typeof timestamp === 'string' ? parseInt(timestamp, 10) : timestamp;

  if (isNaN(ts) || ts === 0) {
    return '-';
  }

  const msTimestamp = ts < 32503680000 ? ts * 1000 : ts;
  const date = new Date(msTimestamp);

  if (isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleString();
}
